import { Link } from "react-router-dom";

export default function Error404() {
  return (
    <div className="error404">
      <i className="fa-solid fa-circle-exclamation fa-shake"></i>
      <h1>The page you were looking for does not exist</h1>
      <p>
        If you were brought here after clicking a link, then the link is wrong.
        Please let us know in our{" "}
        <Link
          rel="noopener"
          target="_blank"
          to="https://dsc.gg/tropicalroleplay"
        >
          Discord server
        </Link>{" "}
        if this is the case
      </p>
    </div>
  );
}
